import { useSyncExternalStore } from 'react';

function getMap(hash: string) {
  const map = new Map<string, string>();

  if (hash.length === 0) return map;

  hash
    .replaceAll(/#|\?/g, '')
    .split('&')
    .forEach((hashItem) => {
      const part = hashItem.split('=');

      if (part[0].length) {
        map.set(part[0], part.length > 1 ? part[1] : 'true');
      }
    });

  return map;
}

const subscribe = (onHashChange: () => void) => {
  window.addEventListener('hashchange', onHashChange);
  return () => window.removeEventListener('hashchange', onHashChange);
};

export const useHash = () => {
  const hash = useSyncExternalStore(
    subscribe,
    () => window.location.hash,
    () => '',
  );

  return getMap(hash);
};
